export default {
    url: 'ocean-smart-electrical-panel-40',
    include: ['us'],
};
